export const DownloadIcon = () => {
  return (
    <span className='ms-icon'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        strokeWidth='2'
        stroke='currentColor'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
        <circle cx='12' cy='12' r='9'></circle>
        <line x1='8' y1='12' x2='12' y2='16'></line>
        <line x1='12' y1='8' x2='12' y2='16'></line>
        <line x1='16' y1='12' x2='12' y2='16'></line>
      </svg>
    </span>
  );
};

export const CopyIcon = () => {
  return (
    <span className='ms-icon'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        strokeWidth='2'
        stroke='currentColor'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
        <rect x='8' y='8' width='12' height='12' rx='2'></rect>
        <path d='M16 8v-2a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2'></path>
      </svg>
    </span>
  );
};

export const CloseIcon = () => {
  return (
    <span className='ms-icon'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        strokeWidth='2'
        stroke='currentColor'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
        <line x1='18' y1='6' x2='6' y2='18'></line>
        <line x1='6' y1='6' x2='18' y2='18'></line>
      </svg>
    </span>
  );
};

export const SearchIcon = () => {
  return (
    <span className='ms-icon'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        strokeWidth='2'
        stroke='currentColor'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
        <circle cx='10' cy='10' r='7'></circle>
        <line x1='21' y1='21' x2='15' y2='15'></line>
      </svg>
    </span>
  );
};

export const PaintIcon = () => {
  return (
    <span className='ms-icon'>
      <svg
        width='24px'
        height='24px'
        viewBox='0 0 24 24'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <g
            transform='translate(-1516.000000, -1140.000000)'
            fill='currentColor'
            fillRule='nonzero'
          >
            <g transform='translate(1432.000000, 1128.000000)'>
              <g transform='translate(84.000000, 12.000000)'>
                <path
                  d='M12.0033614,0.0266370684 C5.37780089,0.0266370684 0.00672284838,5.39325686 0.00672284838,12.0133179 C0.00672284838,18.6333789 5.37780089,23.9999987 12.0033614,23.9999987 L12.0033614,21.0033285 C12.0033614,19.3483132 13.3461309,18.0066583 15.0025211,18.0066583 L22.3871186,18.0066583 C24.5296089,14.2988375 24.5301463,9.73073926 22.3885284,6.02241533 C20.2469105,2.31409141 16.2883407,0.0286484147 12.0033614,0.0266370684 Z M2.67264253,14.4905652 L1.20638671,12.0133179 L3.60571442,4.82130939 L6.00504214,2.42397323 L14.4026891,1.22530515 L17.428508,4.11542707 C3.65903281,2.19755815 2.67264253,14.4905652 2.67264253,14.4905652 Z'
                  opacity='0.2'
                ></path>
                <path
                  d='M15.0025211,18.0066583 L22.3871186,18.0066583 C25.1022533,13.3078092 24.3198637,7.37260223 20.4796311,3.53645943 C16.6393986,-0.299683364 10.6990772,-1.08002786 5.99696323,1.63395795 C1.29484925,4.34794377 -0.996349968,9.87939176 0.410956143,15.1197812 C1.81826225,20.3601707 6.57309151,24.0025483 12.0033614,24 L12.0033614,21.0033285 C12.0033614,19.3483132 13.3461309,18.0066583 15.0025211,18.0066583 Z'
                  opacity='0.1'
                ></path>
                <path d='M14.4026891,10.2153157 C14.4026891,11.2083249 15.2083508,12.0133179 16.2021849,12.0133179 C17.196019,12.0133179 18.0016807,11.2083249 18.0016807,10.2153157 C18.0016807,9.2223066 17.196019,8.41731363 16.2021849,8.41731363 C15.2083508,8.41731363 14.4026891,9.2223066 14.4026891,10.2153157 L14.4026891,10.2153157 Z'></path>
                <path d='M9.60403371,6.61931151 C9.60403371,7.61232066 10.4096954,8.41731363 11.4035295,8.41731363 C12.3973636,8.41731363 13.2030253,7.61232066 13.2030253,6.61931151 C13.2030253,5.62630236 12.3973636,4.82130939 11.4035295,4.82130939 C10.4096954,4.82130939 9.60403371,5.62630236 9.60403371,6.61931151 L9.60403371,6.61931151 Z'></path>
                <path d='M4.80537828,10.2153157 C4.80537828,11.2083249 5.61103998,12.0133179 6.60487407,12.0133179 C7.59870815,12.0133179 8.40436985,11.2083249 8.40436985,10.2153157 C8.40436985,9.2223066 7.59870815,8.41731363 6.60487407,8.41731363 C5.61103998,8.41731363 4.80537828,9.2223066 4.80537828,10.2153157 L4.80537828,10.2153157 Z'></path>
                <path d='M20.8942036,15.6093221 L15.0025211,15.6093221 C12.0240591,15.6166431 9.61136083,18.0273388 9.60403371,21.0033285 L9.60403371,21.3096548 C4.77970544,20.0650105 1.71098047,15.3386375 2.53985743,10.4295883 C3.36873438,5.52053903 7.81950541,2.06170161 12.7854909,2.46737676 C17.7514764,2.8730519 21.5808495,7.00830063 21.6006723,11.9866808 C21.5948227,12.3873517 21.5681275,12.7874478 21.5206947,13.1853489 L23.9200224,13.1853489 C23.9674552,12.7874478 23.9941504,12.3873517 24,11.9866808 C24,5.36661979 18.628922,0 12.0033614,0 C5.37780089,0 0.00672284838,5.36661979 0.00672284838,11.9866808 C0.00672284838,18.6067418 5.37780089,23.9733616 12.0033614,23.9733616 L12.0033614,21.0033285 C12.0033614,20.2085621 12.3193434,19.4463473 12.8817949,18.8843626 C13.4442465,18.322378 14.2070945,18.0066583 15.0025211,18.0066583 L22.3871186,18.0066583 C22.8170396,17.2462724 23.1655351,16.4427198 23.4268273,15.6093221 L20.8942036,15.6093221 Z'></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
};
